<div class="container workbook">
  <div class="row justify-content-center">
    <div class="col-12">
      <div class="dakkini-card p-2 py-5">
        <h2 class="text-uppercase text-center">Workbook</h2>
        <accordion [isAnimated]="true" [closeOthers]="true" >
          <accordion-group *ngFor="let item of items; let i = index " 
            [heading]="item.title" 
            [panelClass]="customClass"
            [id]="'item'+i"
            (isOpenChange)="this.collapseChange($event,'item'+i)">
            <div [innerHTML]="htmlText(item.content)"></div>
          </accordion-group>
        </accordion>
      </div>
    </div>
  </div>
</div>
<scroll-top-floating-component></scroll-top-floating-component>
